/**
 * Conference video rail on the retail-awards layout
 * (Elements/newsstudios/AWARDS_C.ctp, Layouts/retail-awards.ctp).
 *
 * The same mechanism as lib/editions.js, for the same reasons — Splide's swipe,
 * keyboard, ARIA and the arrows' disabled state at the ends, and it is already
 * in the bundle — only the cards differ: 16:9 video cards rather than 9:16
 * posters, so the fixed width is 17rem (19rem from `lg`) instead of 15rem /
 * 17rem. `fixedWidth`, not `perPage`: the strip shows however many fit, with
 * the next one peeking — that peek is what says "there is more".
 *
 * No `rewind` and no autoplay: a rail of videos is browsed, not presented.
 *
 * The arrows are AWARDS_C's own buttons in the heading row (Splide picks up
 * `.splide__arrow--prev|next` anywhere under the root); their skin is
 * `.video-rail .splide__arrow` in components.css, shared with `.editions`.
 */
import Splide from '@splidejs/splide';
import { qs, prefersReducedMotion } from './dom.js';

export function setupVideoRail() {
  const root = qs('[data-video-rail]');
  if (!root) return;

  // One card needs no carousel — see hero.js for the same guard.
  if (root.querySelectorAll('.splide__slide').length < 2) return;

  const splide = new Splide(root, {
    type: 'slide',
    fixedWidth: '17rem',
    gap: '1.25rem',
    perMove: 1,
    // Read from the document, never hardcoded — see hero.js.
    direction: document.documentElement.getAttribute('dir') === 'ltr' ? 'ltr' : 'rtl',
    arrows: true,
    pagination: false,
    // Stop at the last card instead of leaving blank track after it.
    trimSpace: 'move',
    speed: prefersReducedMotion() ? 0 : 500,
    // `lg` in tokens.css. mediaQuery 'min' so the breakpoint reads up from
    // the phone width, like the Tailwind classes beside it.
    mediaQuery: 'min',
    breakpoints: {
      1024: { fixedWidth: '19rem' },
    },
    i18n: {
      prev: 'ویدیوهای قبلی',
      next: 'ویدیوهای بعدی',
      carousel: 'ویدیوهای همایش',
      slide: 'ویدیو',
      slideLabel: 'ویدیو %s از %s',
    },
  });

  splide.mount();
  return splide;
}
